import { FETCH_VM_BRAND_MODEL_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 10,
  },
};

const vmBrandModelList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VM_BRAND_MODEL_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default vmBrandModelList;
